import React from "react";
import "../assets/styles/Hero.css";

function Hero() {
  return (
    <section id="home" className="hero-section">
      <div className="hero-bg" aria-hidden="true" />
      <div className="hero-overlay" aria-hidden="true" />

      {/* ── Centered heading ── */}
      <div className="hero-content">
        <h1 className="hero-title">
          Awaken to
          <br />
          <em>Nature's Finest</em>
          <br />
          Retreat
        </h1>
      </div>

      {/* ── Scroll down arrow ── */}
      <div className="hero-scroll-hint" aria-hidden="true">
        <div className="scroll-mouse">
          <div className="scroll-wheel" />
        </div>
        <span className="scroll-label">Scroll</span>
      </div>
    </section>
  );
}

export default Hero;
